
import Component from 'vue-class-component';
import {
  PracticesClient,
  ShipRepairPracticeDetailsModel
} from "@/api-client";
import {Prop} from "vue-property-decorator";
import PracticePeriodsTable from "@/features/documents/practices/components/PracticePeriodsTable.vue";
import Files from "@/components/Files.vue";
import PracticeDetailsContentBase from "@/features/documents/practices/components/PracticeDetailsContentBase";
import HeadingGroup from "@/features/shared/components/HeadingGroup.vue";

@Component({
  components: {
    HeadingGroup,
    PracticePeriodsTable,
    Files
  },
})
export default class PracticeShipRepairDetailsContent extends PracticeDetailsContentBase {
  @Prop()
  details!: ShipRepairPracticeDetailsModel;
  @Prop()
  isOfficial?: boolean;
  
  async getDownloadUrl(fileId: string): Promise<string> {
    return (await new PracticesClient().downloadShipRepairFile(this.details.id, fileId)).url;
  }
}
